import { showCapacityLimitPopup } from '../../src/util/capacity-popup'; // FIX 20260725-copylimit
// カンマ区切りIDリストから指定IDだけを厳密に取り除く
// (部分一致replaceだとIDの一部にマッチして区切りのカンマごと消え、別IDと連結する不具合が起きる)
window.tmRemoveIdFromCsv = window.tmRemoveIdFromCsv || function (csv, id) {
  var ids = String(csv || '').split(',').filter(function (v) { return v && v !== String(id); });
  return ids.length ? ids.join(',') + ',' : '';
};
export default class AkaireFile {
  openModalSettingStatusAkaireFile(task_id, project_id, current_status, bypass_confirm) {
    $('#offTaskNoticeStatus').find('.submit-update-status').attr('data-task-id', task_id)
    $('#offTaskNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    $('#onTaskNoticeStatus').find('.submit-update-status').attr('data-task-id', task_id)
    $('#onTaskNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    const bypass_after_setting = $('#tbody-list-akaire_file').attr('data-show-confirm-again')
    if((bypass_confirm === 'false' || bypass_confirm === '') && bypass_after_setting === 'false') {
      if(current_status || current_status === 'true') {
        Shared.showModalForElement('#offTaskNoticeStatus')
      } else {
        Shared.showModalForElement('#onTaskNoticeStatus')
      }
    } else {
      this.updateNotifyStatus($('#onTaskNoticeStatus').find('.submit-update-status'), !current_status)
    }
  }

  cannotSettingNotify() {
    $('#cannotSettingNotify').modal('show')
  }

  updateNotifyStatus(element, status) {
    let task_id = $(element).attr('data-task-id')
    let url = Routes.update_notify_status_akaire_file_index_path()
    Shared.callAjax(url, { status: status, akaire_file_id: task_id }, 'json')
    .done(function(data) {
      if(data.status) {
        $('#onTaskNoticeStatus').modal('hide')
        $(`#status-${task_id}`).find('.accept-notify').removeClass("d-none")
        $(`#status-${task_id}`).find('.reject-notify').addClass("d-none")
        $(`.thumb-status-${task_id}`).find('.accept-notify').removeClass("d-none")
        $(`.thumb-status-${task_id}`).find('.reject-notify').addClass("d-none")
        $(`#sp-thumb-status-${task_id}`).find('.accept-notify').removeClass("d-none")
        $(`#sp-thumb-status-${task_id}`).find('.reject-notify').addClass("d-none")
      } else {
        $('#offTaskNoticeStatus').modal('hide')
        $(`#status-${task_id}`).find('.accept-notify').addClass("d-none")
        $(`#status-${task_id}`).find('.reject-notify').removeClass("d-none")
        $(`.thumb-status-${task_id}`).find('.accept-notify').addClass("d-none")
        $(`.thumb-status-${task_id}`).find('.reject-notify').removeClass("d-none")
        $(`#sp-thumb-status-${task_id}`).find('.accept-notify').addClass("d-none")
        $(`#sp-thumb-status-${task_id}`).find('.reject-notify').removeClass("d-none")
      }
      // 通知設定変更後のトースト表示用にメッセージをsessionStorageに保存
      // （reload後、akapon_common_modal_header_master.js が読み取って表示）
      try {
        var scope = $(element).attr('data-tm-notify-scope') || 'このファイル';
        var newState = data.status ? 'ON' : 'OFF';
        var msg = scope + 'の通知設定が' + newState + 'に変わりました。';
        sessionStorage.setItem('tm_notify_toast', JSON.stringify({ message: msg }));
      } catch (e) {
        // sessionStorage アクセス失敗時は何もしない（既存動作を妨げない）
      }
      location.reload()
    }).fail(function(result) {
      $('#onTaskNoticeStatus').modal('hide')
      $('#offTaskNoticeStatus').modal('hide')
      $('#cannotSettingNotify').modal('show')
    })
  }

  changeStatus(element, akaireFileID, projectID, status_new) {
    if ($(element).hasClass('active')) return

    const componentChangeStatus = $(`#status-akaire_file-${akaireFileID}`)
    const status_old = componentChangeStatus.attr('data-status-old')
    const url = Routes.akaire_change_status_akaire_file_index_path(akaireFileID)
    const statusStyle = this.fetchStatusStyle(status_new);
    const oldStatusStyle = this.fetchStatusStyle(status_old);
    Shared.callAjax(url, { status: status_new }).done(function(data) {
      componentChangeStatus.removeClass(oldStatusStyle).addClass(statusStyle)
      componentChangeStatus.attr('data-status-old', status_new)
      $(`#modalSelectStatus-${akaireFileID}`).find('li').removeClass('active')
      $(`#modalSelectStatus-${akaireFileID}`).find(`li[data-status='${status_new}']`).addClass('active')
      $(`#modalSelectStatus-${akaireFileID}`).find('.current-status-text').empty();
      $(`#modalSelectStatus-${akaireFileID}`).find(`li[data-status='${status_new}'] .current-status-text`).text("（現在のステータス）")
      $(`#modalSelectStatus-${akaireFileID}`).modal('hide')

      if (window.innerWidth < gon.shared.break_point_for_mobile) {
        Popup.confirm('', {
          description: Shared.textTaskAkaire(I18n.t('task.update.status.success'), I18n.t('task.update.status.success_akapon')),
          confirmText: 'OK',
          cancelBtn: 'false',
          success: () => { window.location.reload() },
          cancel: () => { window.location.reload() },
        })
        return
      }
      // ステータス変更成功トースト（ステータス名を含む）
      var statusLabel = element ? element.textContent.trim().replace('（現在のステータス）', '').trim() : status_new;
      Popup.alert('ファイルのステータスが「' + statusLabel + '」に変更されました。');
    }).fail(function(data) {
      if (data.status && data.status_code === 401) {
        Popup.alert(Shared.textTaskAkaire(I18n.t('task.update.status.not_permission'), I18n.t('task.update.status.success_akapon')))
        return
      }
      Popup.alert(data.error)
    })
  }

  showHideSettingPic(objectId, akaireFileId) {
    const url = Routes.participants_for_akaire_file_index_path(objectId)
    Shared.callAjax(url, { object_id: objectId, akaire_file_id: akaireFileId }, 'script', 'GET')
  }

  showModalChangeStatusSp(ele, akaireFileId) {
    $(`#modalMenu-${akaireFileId}`).modal('hide')
    // Bootstrap内部状態をリセットしてから開く
    var statusModal = $(`#modalSelectStatus-${akaireFileId}`);
    var bsModal = statusModal.data('bs.modal');
    if (bsModal) {
      bsModal._isShown = false;
      bsModal._isTransitioning = false;
    }
    statusModal.modal('show')
  }

  settingDeadlineDate(ele, akaireFileId, objectId) {
    const expirationModal = $(`#modal_expiration_task_${akaireFileId}`)
    const parentModal = $(ele).closest('.modal[id^="modalMenu-"]')

    if (parentModal.length) {
      expirationModal.attr('data-tm-parent-modal-id', parentModal.attr('id'))
    } else {
      expirationModal.removeAttr('data-tm-parent-modal-id')
    }

    expirationModal.modal('show')
  }

  setExpirationDate(ele, objectId, akaireFileId) {
    const modalComponent = $(ele).parents('.modal_expiration_task')
    const startDate = modalComponent.find('#expiration-date-start').val()
    const endDate = modalComponent.find('#expiration-date-end').val()
    const color = modalComponent.find(`input#colorInput_task_${akaireFileId}`).val()
    const url = Routes.change_dateline_for_akaire_file_index_path(objectId)
    const akaire = this
    Shared.callAjax(url, { akaire_file_id: akaireFileId, start_date: startDate, due_date: endDate, colors: color }).done(function(data) {
      $('#file-expiration-date-' + akaireFileId + '-' + objectId).text(endDate)
      modalComponent.find('#expiration-date-start').data('current-date', startDate)
      modalComponent.find('#expiration-date-end').data('current-date', endDate)
      akaire.refreshCurrentGanttChart()
      akaire._showPopupReload('期限を更新しました。')
    })
    .fail(function(data) {
      akaire._showPopupReload('変更に失敗しました。')
    })
  }

  _showPopupReload(message) {
    Popup.confirm(message, {
      cancelBtn: 'false',
      confirmText: 'OK',
      successBtn: 'false',
      width: 'auto',
      kind: 'akaire',
      timer: 3000
    })
  }

  refreshCurrentGanttChart() {
    if (typeof window.refreshCurrentGanttChart === 'function') {
      window.refreshCurrentGanttChart()
    }
  }

  settingNotifyShowAgain(element, type) {
    const url = Routes.setting_show_again_notify_akaire_file_index_path()
    const check_status = $(element).is(":checked")
    $(`#tbody-list-${type}`).attr('data-show-confirm-again', check_status)
    Shared.callAjax(url, { checked: check_status, type: type })
  }

  colorPlanAkapon(){
    const plan_akapon = $('body').find('nav#navbar-common').data('plan-akapon');
    if (plan_akapon == 'undefined'){
      return '#202f55';
    }
    return plan_akapon ? '#E60C11' : '#202f55';
  }

  resetExpirationDate(ele, taskId) {
    const modalComponent = $(ele).parents('.modal-content');
    let color = $(ele).attr('data-current-color') || 'blue';
    modalComponent.find('input#expiration-date-start').val('');
    modalComponent.find('input#expiration-date-end').val('');
    modalComponent.find('#colorPicker').find(`div[data-color="${color}"]`).trigger('click');
  }

  fetchStatusStyle(status_task) {
    let status_style = ''
    switch(status_task) {
      case 'preparation':
          status_style = 'status_green_point'
          break;
      case 'working':
          status_style = 'status_orange_point'
          break;
      case 'complete':
          status_style = 'status_red_point'
          break;
      case 'on_hold':
          status_style = 'status_gray_point'
      break;
    }
    return status_style
  }

  showMessageWithChangeAkaireFileType(ele) {
    const currentValue = $(ele).attr('task_category')
    let description = I18n.t('akaire_file.change_akaire_file_type_web_to_video')
    if (currentValue !== $(ele).val()) {
      if($(ele).val() == 'web') {
        description = I18n.t('akaire_file.change_akaire_file_type_video_to_web')
      }

      Popup.confirm('',{
        description: description,
        confirmText: 'OK',
        cancelText: 'キャンセル',
        success: () => {
          $(ele).attr('task_category', $(ele).val())
          this.submitEditTaskDetail()
        },
        cancel: () => {
          $(".edit_task").find("#task_category").val(currentValue)
        }
      })
    }
  }

  submitEditTaskDetail() {
    $('.bootstrap-datetimepicker-widget').hide().remove()
    $('.datetimepicker').each(function() {
      const picker = $(this).data('DateTimePicker')
      if (picker) {
        picker.hide()
      }
    })
    $("#submit-edit-task").click()
  }


  showSettingPicProject(projectId, akaireFileId) {
    const url = Routes.project_participants_akaire_file_index_path(projectId)
    Shared.callAjax(url, { akaire_file_id: akaireFileId }, 'script', 'GET')
  }

  handelCheckLimited(element, userID, userName) {
    const projectId = $(element).attr('data-project-id');
    const akaireFileId = $(element).attr('data-akaire-file-id');
    const parentTaskId = $(element).attr('data-task-id') || '';
    const parentTaskName = $(element).attr('data-task-name') || '';
    const __isOwner = String($(element).attr('data-is-owner')) !== 'false';
    $.ajax({
      url: `/projects/${projectId}/limited_member_detail`,
      method: 'GET',
      data: { user_id: userID, task_id: parentTaskId }
    }).done((res) => {
    let html = `${userName}さんは、限定メンバーです。<br><br>`;
    const esc = (t) => $('<div>').text(t).html();
    if (parentTaskId && parentTaskName) {
      html += `<div style="font-weight:700;margin-bottom:4px;">【招待されているタスク】</div>`;
      html += `&nbsp;・${esc(parentTaskName)}<br><br>`;
    }
    const footnote = `<div style="font-size:12px;color:#bbb;line-height:1.6;text-align:left;">※<span style="font-weight:700;">限定メンバー：</span>プロジェクトに招待されていないメンバーが、特定のタスク・ファイルにだけ直接招待されている状態です。<br>※<span style="font-weight:700;">通常招待：</span>チームメンバーは、このプロジェクト配下すべてに招待され、外部メンバーは、新しく作成されるタスク・ファイルに自動招待に切り替わります。（現在の招待先はそのまま残ります）</div>`;
    const footnoteLimitedOnly = `<div style="font-size:12px;color:#bbb;line-height:1.6;text-align:left;">※<span style="font-weight:700;">限定メンバー：</span>プロジェクトに招待されていないメンバーが、特定のタスク・ファイルにだけ直接招待されている状態です。</div>`;
    Popup.limitedModal(html, {
      isOwner: __isOwner,
      footnote: footnote,
      footnoteLimitedOnly: footnoteLimitedOnly,
      onRevoke: () => {
        $.ajax({
          url: `/projects/${projectId}/revoke_limited_file_member`,
          method: 'DELETE',
          data: { user_id: userID, akaire_file_id: akaireFileId },
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
        }).done(() => {
          if (Number(userID) === Number(gon?.shared?.current_user?.id)) {
            $('.modal-backdrop').remove();
            $('#popupInviteMember').modal('hide');
            Popup.alert('ファイルのメンバーから解除されました', '', '', {timer:2500, allowOutsideClick:false, allowEscapeKey:false});
            setTimeout(() => location.reload(), 2500);
            return;
          }
          const __row = $(element).closest('tr, .show-list-member-for-page'); if (__row.length) { __row.remove(); } else { $(`tr.tr-${userID}`).remove(); }
          Popup.alert(`${userName}さんの招待を解除しました。`, '', '', {timer:3000, allowOutsideClick:false, allowEscapeKey:false});
        }).fail(() => {
          Popup.alert('解除に失敗しました。');
        });
      },
      onPromote: () => {
        $.ajax({
          url: `/projects/${projectId}/promote_limited_member`,
          method: 'POST',
          data: { user_id: userID, task_id: '' },
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
        }).done(() => {
          const __cell = $(element).closest('td');
          __cell.html(`<label class="checkbox_noborder_intable"><input type="checkbox" data-user-id="${userID}" class="check-box-check-member" onchange="AkaireFile.handleCheckToAddPermission(this, '${userID}')" name="permission[${userID}]" checked><span class="checkbox_text"></span></label>`);
          Popup.alert('通常招待に切替えました。', '', '', {timer:3000, allowOutsideClick:false, allowEscapeKey:false});
        }).fail(() => {
          Popup.alert('通常招待への切替えに失敗しました。');
        });
      }
    });
    });
  }
  handleCheckToAddPermission(element, userID){
    $('#popupInviteMember').find('#element-is-change').val('true')
    const isAssignAkaireFile = $('#assignAkairePopup').length > 0;

    if($(element).is(":checked")) {
      if ($(element).parents('.checkbox_noborder_intable').hasClass('c-red-check')) {
        $(element).parents('.show_permission_tr').attr('is-new-add', 'true')
        this.showEleFilterNewAdd()
      } else if (isAssignAkaireFile) {
        this.showEleFilterNewAdd()
      }
      $(element).parent().parent().parent().find('.label-checkbox').removeClass("disabled")
    } else {
      if ($(element).parents('.checkbox_noborder_intable').hasClass('c-red-check')) {
        $(element).parents('.show_permission_tr').removeAttr('is-new-add')
        this.showEleFilterNewAdd(false)
      } else if (isAssignAkaireFile) {
        this.showEleFilterNewAdd(false)
      }
      $(element).parent().parent().parent().find('.label-checkbox').addClass('disabled')
    }

    const dataUserDelete = $(".list-user-delete");
    const dataUserAdd = $('.list-user-new-checked-akaire-file')
    if (dataUserAdd.length > 0) {
      if($(element).is(":checked")) {
        dataUserAdd.val(`${dataUserAdd.val()}${userID},`)
      } else {
        dataUserAdd.val(tmRemoveIdFromCsv(dataUserAdd.val(), userID))
      }
    }
    if(dataUserDelete.length > 0) {
      let currentVal = dataUserDelete.val() || '';
      currentVal = tmRemoveIdFromCsv(currentVal, userID);

      if(!$(element).is(":checked")) {
        currentVal += `${userID},`;
      }

      dataUserDelete.val(currentVal);
    }

    if (isAssignAkaireFile && typeof Project !== 'undefined' && Project.refreshInviteMemberCheckedFilter) {
      Project.refreshInviteMemberCheckedFilter();
    }
  }

  showEleFilterNewAdd(isPositive = true) {
    const spanShow = $('#popupInviteMember').find('.show-number-member-add')
    const number = isPositive ? Number(spanShow.attr('data-number')) + 1 : Number(spanShow.attr('data-number')) - 1
    const isCheckedFilterMode = spanShow.data('filter-mode') === 'checked'
    const isShowingSelectedOnly = spanShow.attr('is-show') === 'true'
    spanShow.attr('data-number', number)
    if (!isShowingSelectedOnly) {
      const text = window.innerWidth <= 576 ? '名' : spanShow.data('text')
      spanShow.text(`${number}${text}`)
    } else {
      const textHide = window.innerWidth <= 576 ? '戻る' : spanShow.attr('data-text-hide')
      spanShow.text(textHide)
    }

    if (number <= 0 && !(isCheckedFilterMode && isShowingSelectedOnly)) {
      spanShow.addClass('d-none')
    } else {
      spanShow.removeClass('d-none')
    }
  }

  handleUpdatePicOfTask(element, objectId, akaireFileId) {
    let user_invite_ids = [];
    const user_delete_ids = $('#list-user-uncheck').val().split(',').filter(Boolean);
    let user_invite_emails = [];
    let list_invite_member_of_partner = [];
    $(element).parent().parent().find(".pick-pics").each(function( _index, ele ) {
      if($(ele).is(":checked")) {
        if($(ele).attr("name").includes("email")) {
          user_invite_emails.push({email: $(ele).val(), type: $(ele).attr("data-type")})
        } else if($(ele).attr("name").includes("partners")) {
          list_invite_member_of_partner.push({email: $(ele).val(), type: $(ele).attr("data-type"), company_id: $(ele).attr("data-company-id"), name: $(ele).attr("data-name")})
        } else {
          user_invite_ids.push($(ele).val())
        }
      }
    });
    const url = Routes.update_pic_for_task_or_ticket_akaire_file_index_path(objectId)
    Shared.callAjax(url,
      { list_user_invite: user_invite_ids, list_user_delete: user_delete_ids,
        list_user_invite_by_email: user_invite_emails, akaire_file_id: akaireFileId,
        list_invite_member_of_partner: list_invite_member_of_partner
      }
    ).done(function(result){
      if(result.self_remove) {
        $('.modal-backdrop').remove();
        $('#personInChargeOfObject').modal('hide');
        Popup.alert(`ファイル「${result.removed_object_name}」のメンバーから解除されました`, '', '', {timer:2500, allowOutsideClick:false, allowEscapeKey:false});
        setTimeout(() => location.reload(), 2500);
        return;
      }
      $("#personInChargeOfObject").modal("hide")
      if (result.number_user === 0) {
        $(`#pic_list_${result.task_id}`).html('自分')
        $(`#sp_pic_list_${result.task_id}`).html('1名')
        $(`.akaire-file-member-${result.task_id}`).html(1)
      } else {
        $(`#pic_list_${result.task_id}`).html(`自分と他${result.number_user}名`)
        $(`#sp_pic_list_${result.task_id}`).html(`${result.number_user + 1}名`)
        $(`.akaire-file-member-${result.task_id}`).html(result.number_user + 1)
      }
      if (result.is_uncheck_member) {
        Popup.alert('メンバーを更新しました。')
      }else {
        Popup.alert('メンバーを更新しました。<br>新しいファイルの作成権限も付与されます。')
      }
      document.dispatchEvent(new CustomEvent('akaireProjectMembersUpdated'))
      $('.list-permission').find('.list-permission-name').html(result.approve_participants_name)
    }).fail(function() {
      Popup.confirm(I18n.t('work.changed_refresh'), {
        success: () => {
          window.location.reload()
        },
        cancel: () => {
          window.location.reload()
        },
        confirmText: 'OK',
        cancelBtn: 'false',
        width: '35rem'
      })
    })
  }

  showLimitedWaitingModal(element, projectId, objectId, objectType, akaireFileId, user_id, user_name) {
    const akaire = this
    const taskId = objectType == 'Task' ? objectId : null
    $.ajax({
      url: `/projects/${projectId}/limited_member_detail`,
      method: 'GET',
      data: taskId ? { user_id: user_id, task_id: taskId } : { user_id: user_id }
    }).done((res) => {
      let html = `${user_name}さんは、限定メンバーとして承認待ち状態です。<br><br>`;
      const esc = (t) => $('<div>').text(t).html();
      if (res.task_names && res.task_names.length > 0) {
        html += `<div style="font-weight:700;margin-bottom:4px;">【招待されているタスク】</div>`;
        res.task_names.forEach((n) => { html += `&nbsp;・${esc(n)}<br>`; });
        if (res.task_more > 0) html += `&nbsp;他${res.task_more}件<br>`;
        html += `<br>`;
      }
      if (res.file_names && res.file_names.length > 0) {
        html += `<div style="font-weight:700;margin-bottom:4px;">【招待されているファイル】</div>`;
        res.file_names.forEach((n) => { html += `&nbsp;・${esc(n)}<br>`; });
        if (res.file_more > 0) html += `&nbsp;他${res.file_more}件<br>`;
        html += `<br>`;
      }
      const footnoteLimitedOnly = `<div style="font-size:12px;color:#bbb;line-height:1.6;text-align:left;">※<span style="font-weight:700;">限定メンバー：</span>プロジェクトに招待されていないメンバーが、特定のタスク・ファイルにだけ直接招待されている状態です。</div>`;
      Popup.limitedModal(html, {
        isOwner: false,
        footnoteLimitedOnly: footnoteLimitedOnly,
        onRevoke: () => {
          let url = Routes.remove_member_unapprove_of_file_akaire_file_index_path(akaireFileId)
          if(objectType == 'Work') url = Routes.owner_project_ticket_remove_member_unapprove_path(projectId, objectId)
          Shared.callAjax(url, {user_id: user_id}, 'json', 'post')
          .done(() => {
            const __row2 = $(element).closest('tr, .show-list-member-for-page'); if (__row2.length) __row2.remove();
            Popup.alert(`${user_name}さんの招待を解除しました。`, '', '', {timer:3000, allowOutsideClick:false, allowEscapeKey:false})
            akaire.showHideSettingPic(objectId, akaireFileId)
          })
          .fail(() => { Popup.alert('解除に失敗しました。') });
        }
      });
    });
  }

  handleCheckRemoveUnapproveMember(element, projectId, objectId, objectType, akaireFileId) {
    let user_name = $(element).parent().find(".t_name").text()
    let user_id = $(element).attr("data-user-id")
    const isLimitedWaiting = String($(element).attr('data-limited')) === 'true';
    if (isLimitedWaiting) { this.showLimitedWaitingModal(element, projectId, objectId, objectType, akaireFileId, user_id, user_name); return; }
    const akaire = this
    Popup.confirm(`${user_name}さんは、承認待ち状態です。<br> 解除してよろしいですか？`, {
        confirmText: 'OK',
        success: () => {
          let url = Routes.remove_member_unapprove_of_file_akaire_file_index_path(akaireFileId)
          if(objectType == 'Work') url = Routes.owner_project_ticket_remove_member_unapprove_path(projectId, objectId)
          Shared.callAjax(url, {user_id: user_id}, 'json', 'post')
          .done(function(data) {
            const __row3 = $(element).closest('tr, .show-list-member-for-page'); if (__row3.length) __row3.remove();
            Popup.alert(`${user_name}さんの招待を解除しました。`, '', '', {timer:3000, allowOutsideClick:false, allowEscapeKey:false})
            akaire.showHideSettingPic(objectId, akaireFileId)
          })
          .fail(function(data) {
            Popup.confirm('',{
              description: 'false',
              confirmText: 'OK',
              cancelBtn: 'false',
            })
          })
        },
      }
    )
  }

  handleCheckRemoveUnapproveRequest(element, project_id, task_id, akaireFileId) {

  }

  onClickSetPasswordUrl(ele, akaireFileId, isCreatePass) {
    const componentModal = $(ele).parents('.modal-body');
    const divParent = $(ele).parents('.show-content-on-off-share-password')
    $(ele).prop('checked', false)
    divParent.find('.show-on').addClass('d-none')
    divParent.find('.show-off').removeClass('d-none')
    if (typeof is_password_plan_free_or_light !== 'undefined' && is_password_plan_free_or_light) {
      Popup.confirm(
        `チームアカウントがStandardプラン以上を<br>ご契約の場合にご利用いただけます。<br>現在のアカウントは「${plan_name}プラン」のため、<br>本機能はご利用いただけません。`,
        {
          success: () => {
            $(ele).closest('.modal').css('z-index', 1050);
            Subscription.openPlanHeaderModal();
          },
          cancel: () => {},
          confirmText: 'プラン変更',
          cancelText: 'キャンセル',
          width: 'auto',
          kind: 'akaire',
        }
      )
      return
    }
    if (isCreatePass === 'false') {
      Popup.alert('パスワード設定の権限がありません。')
      return
    }
    if ($(ele).is(':checked')) {
      divParent.find('.show-on').removeClass('d-none')
      divParent.find('.show-off').addClass('d-none')
      componentModal.find('.demo-pass-share-akaire-file').addClass('d-none')
      componentModal.find('.show-change-pass-share-akaire').removeClass('d-none')
    } else {
      const divEle = $(ele).parents('.show-text-of-modal-share-akaire-file')
      const password = divEle.attr('data-password')
      const divForPass = divEle.find('.show-all-input-pass-share')
      if (password.length > 0) {
        Popup.confirm(
          'パスワード設定をOFFにすると<br>設定したパスワードはリセットされます。<br>OFFにしてよろしいですか？',
          {
            success: () => {
              this._handleSetPassWordShare(akaireFileId, '', divForPass, divEle, false)
              this._handleOffSharePass(divParent, componentModal)
            },
            cancel: () => {
              $(ele).prop('checked', true)
            },
            confirmText: 'OK',
            width: 'auto',
          }
        )
        return
      }
      this._handleOffSharePass(divParent, componentModal)
    }
  }

  _handleOffSharePass(divParent, componentModal) {
    divParent.find('.show-on').addClass('d-none')
    divParent.find('.show-off').removeClass('d-none')
    componentModal.find('.demo-pass-share-akaire-file').addClass('d-none')
    componentModal.find('.show-change-pass-share-akaire').addClass('d-none')
  }

  checkPassWordShare(ele) {
    if ($(ele).val().length >= 6) {
      $(ele).parents('.show-change-pass-share-akaire').find('.btn-save-password-share').attr('disabled', false)
    } else {
      $(ele).parents('.show-change-pass-share-akaire').find('.btn-save-password-share').attr('disabled', true)
    }
  }

  savePassWordShare(ele, akaireFileId) {
    const password = $(ele).parents('.show-change-pass-share-akaire').find('.input-share-video').val()
    const divParent = $(ele).parents('.show-all-input-pass-share')
    const divEle = $(ele).parents('.show-text-of-modal-share-akaire-file')
    this._handleSetPassWordShare(akaireFileId, password, divParent, divEle)
  }

  _handleSetPassWordShare(akaireFileId, password, divParent, divEle, isChangeShow = true) {
    const url = Routes.set_password_for_share_akaire_file_index_path(akaireFileId)
    Shared.callAjax(url, { password: password }).done(function(data) {
      if (isChangeShow) {
        divParent.find('.demo-pass-share-akaire-file').removeClass('d-none')
        divParent.find('.show-change-pass-share-akaire').addClass('d-none')
      }
      divEle.find('.input-share-video').val(password)
      divEle.attr('data-password', password)
      Popup.alert('パスワードを保存しました。')
    })
    .fail(function(data) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  changeFocusInput(ele) {
    const divParent = $(ele).parents('.show-all-input-pass-share')
    divParent.find('.demo-pass-share-akaire-file').addClass('d-none')
    divParent.find('.show-change-pass-share-akaire').removeClass('d-none')
  }

  showUploadAnimation(ele, akaireFIleId, url, fileName) {
    Popup.confirm(
      `「${fileName}」に最新データをアップロードします。<br>ファイルに移動します。よろしいですか？`,
      {
        success: () => {
          window.location = `${url}?show_upload_animation=true`
        },
        cancel: () => {},
        confirmText: 'OK',
        width: 'auto',
      }
    )
  }

  downloadComment(ele, url) {
    if (url === '') {
      Popup.alert('データがありません。')
      return
    }
    window.location.href = url;
    Popup.alert('ダウンロードが完了しました。')
  }

  changeTypeFile(ele, akaireFIleId, newType, currentType) {
    if (currentType === newType) return

    const text = newType === 'web' ? 'WEB' : '動画'
    Popup.confirm(
      `ファイル種別を${text}に変更します。<br>種別を変更すると、前の種別データは削除されます。<br>変更してよろしいですか？`,
      {
        success: () => {
          this._handleChangeType(ele, akaireFIleId, newType)
        },
        cancel: () => {},
        confirmText: 'OK',
        width: 'auto',
      }
    )
  }

  _handleChangeType(ele, akaireFIleId, newType) {
    const url = Routes.change_type_akaire_akaire_file_index_path(akaireFIleId)
    Shared.callAjax(url, { category: newType }).done((data) => {
      const divELe = $(ele).parents('.display-center-div')
      divELe.find('div[type="button"]').attr('disabled', false)
      $(ele).attr('disabled', true)
      $(ele).parents('.modal').modal('hide')
      location.reload()
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  changeAkaireFileName(ele, akaireFileId) {
    $(`#modal-change-akaire-file-name-${akaireFileId}`).modal('show')
  }

  changeFileName(ele, akaireFileId) {
    const newName = $(ele).parents('.modal-body').find('.input-change-name').val()
    if (newName.length <= 0) {
      $(ele).parents('.modal-body').find('.input-change-name').attr('placeholder', 'ファイル名を入力してください。')
      return
    }
    const url = Routes.change_akaire_file_name_akaire_file_index_path(akaireFileId)
    Shared.callAjax(url, { name: newName }).done((data) => {
      $(ele).parents('.modal').modal('hide')
      Popup.confirm('ファイル名を更新しました。', {
        success: () => { location.reload() },
        cancel: () => {location.reload()},
        successBtn: 'false',
        width: 'auto',
      })
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  copy(akaireFileId, name) {
    const url = Routes.copy_akaire_file_akaire_file_index_path(akaireFileId)
    Shared.callAjax(url, {}).done((data) => {
      var messagePopup = `現在、${name}のコピー中です。<br>コピー完了後、リロードするとファイル一覧に表示されます。<br> ※コピー完了後、ご登録のメールアドレス宛に完了通知が届きます。`
      Popup.alert(messagePopup, '', '', { kind: 'akaire' })
    }).fail((xhr) => {
      // FIX 20260725-copylimit 上限で弾かれた時は既存の案内モーダルを出す（新規文言は作らない）
      const res = (xhr && xhr.responseJSON) || {}
      if (res.error === 'capacity') {
        showCapacityLimitPopup(res.info || {})
        return
      }
      if (res.error === 'file_quantity' && window.Subscription &&
          typeof window.Subscription.openPlanHeaderModalWithFileLimit === 'function') {
        window.Subscription.openPlanHeaderModalWithFileLimit(res.planName, res.maxNum)
        return
      }
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  // FIX 20260724-delmodal 全ファイル一覧と同じ「30日間保管／完全削除」の2択にする。
  // 30日間保管は bulk_delete_akaire_files(mode=keep) を1件で呼ぶ＝中身(ページ・バージョン)を消す経路を通らない。
  delete(akaireFileId, name, fromAkairePage = false) {
    const self = this
    if ($('#akf-del-overlay').length === 0) {
      $('body').append(`
<div id="akf-del-overlay" style="position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:20000;display:none;align-items:center;justify-content:center;">
  <div style="background:#1a1a1a;color:#fff;border-radius:16px;box-shadow:0 20px 48px rgba(0,0,0,.6);padding:32px 28px 24px;max-width:620px;width:calc(100vw - 48px);text-align:left;font-family:sans-serif;">
    <div class="akf-del-body" id="akf-del-main">
      <p style="font-size:15px;line-height:1.8;margin:0 0 12px;font-weight:700;color:#fff;">「<span id="akf-del-name"></span>」ファイルを削除します。</p>
      <p style="font-size:13px;line-height:1.8;margin:0 0 8px;color:#fff;">完全削除の場合に空く容量：<span id="akf-del-size">—</span></p>
      <p style="font-size:14px;line-height:1.8;margin:0 0 8px;color:#fff;">削除方法をお選びください。
        <i class="fas fa-info-circle ml-1" id="akf-del-info" style="cursor:pointer;font-size:20px;vertical-align:middle;"></i>
      </p>
      <p style="font-size:12px;line-height:1.8;margin:0 0 20px;color:#ccc;">※30日間保管データは、<a href="/all_akaire_files" target="_blank" rel="noopener" style="color:#fff;text-decoration:underline;">全ファイル</a>ページから「戻す」「完全削除」ができます。</p>
      <div style="text-align:center;margin-top:20px;">
        <button type="button" class="akf-del-btn" id="akf-del-keep" style="background:rgba(255,255,255,.12);color:#fff;">30日間保管</button>
        <button type="button" class="akf-del-btn" id="akf-del-purge" style="background:#f01f42;color:#fff;">完全削除</button>
        <button type="button" class="akf-del-btn akf-del-close" style="background:rgba(255,255,255,.12);color:#fff;">キャンセル</button>
      </div>
    </div>
    <div class="akf-del-body" id="akf-del-info-body" style="display:none;">
      <p style="font-size:15px;font-weight:700;margin:0 0 6px;color:#fff;">30日間保管（あとから復元できます）</p>
      <p style="font-size:14px;line-height:1.8;margin:0 0 18px;color:#fff;">・削除してから30日間は、全ファイルページ右上のゴミ箱から復元できます。<br>・保管中はデータを残しておくため、空き容量は増えません。<br>・30日を過ぎると自動的に完全削除され、その時点で容量が空きます。</p>
      <p style="font-size:15px;font-weight:700;margin:0 0 6px;color:#fff;">完全削除（復元できません）</p>
      <p style="font-size:14px;line-height:1.8;margin:0 0 18px;color:#fff;">・ファイル内のページ・バージョン・コメントをすべて削除します。<br>・空き容量がすぐに増えます。<br>・削除後に元へ戻すことはできません。</p>
      <div style="text-align:center;margin-top:20px;">
        <button type="button" class="akf-del-btn" id="akf-del-info-back" style="background:rgba(255,255,255,.12);color:#fff;">戻る</button>
      </div>
    </div>
    <div class="akf-del-body" id="akf-del-confirm" style="display:none;">
      <p style="font-size:15px;line-height:1.8;margin:0 0 20px;font-weight:700;color:#fff;">「<span class="akf-del-name2"></span>」を完全削除します。<br>復元できません。よろしいですか？</p>
      <div style="text-align:center;margin-top:20px;">
        <button type="button" class="akf-del-btn" id="akf-del-purge-yes" style="background:#f01f42;color:#fff;">完全削除</button>
        <button type="button" class="akf-del-btn akf-del-close" style="background:rgba(255,255,255,.12);color:#fff;">キャンセル</button>
      </div>
    </div>
    <div class="akf-del-body" id="akf-del-loading" style="display:none;text-align:center;">
      <p style="font-size:15px;font-weight:700;margin:0;color:#fff;">削除しています。しばらくお待ちください…</p>
    </div>
  </div>
</div>
<style>#akf-del-overlay .akf-del-btn{padding:8px 24px;border:none;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;margin:0 4px;}</style>`)
    }

    const show = (which) => {
      $('.akf-del-body').hide()
      $('#' + which).show()
      $('#akf-del-overlay').css('display', 'flex')
    }

    $('#akf-del-name').text(name)
    $('.akf-del-name2').text(name)
    // FIX 20260724-delmodal 画面に容量が無いため、開いた時に1回だけ取得する
    $('#akf-del-size').text('計算中…')
    $.get('/trash_akaire_files', { size_of: akaireFileId })
      .done((res) => { $('#akf-del-size').text(res && res.size ? res.size : '—') })
      .fail(() => { $('#akf-del-size').text('—') })

    $('#akf-del-overlay').off('.akfdel')
    $('#akf-del-overlay').on('click.akfdel', '.akf-del-close', () => { $('#akf-del-overlay').hide() })
    $('#akf-del-overlay').on('click.akfdel', '#akf-del-info', () => { show('akf-del-info-body') })
    $('#akf-del-overlay').on('click.akfdel', '#akf-del-info-back', () => { show('akf-del-main') })
    $('#akf-del-overlay').on('click.akfdel', '#akf-del-purge', () => { show('akf-del-confirm') })
    $('#akf-del-overlay').on('click.akfdel', '#akf-del-keep', () => {
      show('akf-del-loading')
      self._keepDelete(akaireFileId, name, fromAkairePage)
    })
    $('#akf-del-overlay').on('click.akfdel', '#akf-del-purge-yes', () => {
      show('akf-del-loading')
      self._handleDelete(akaireFileId, name, fromAkairePage)
      setTimeout(() => { $('#akf-del-overlay').hide() }, 600)
    })

    show('akf-del-main')
  }

  _humanSize(b) {
    if (!b) { return '0 B' }
    const u = ['B', 'KB', 'MB', 'GB', 'TB']
    let i = 0, v = b
    while (v >= 1024 && i < u.length - 1) { v /= 1024; i++ }
    return (Math.round(v * 10) / 10) + ' ' + u[i]
  }

  // FIX 20260724-delmodal 30日間保管：全ファイル一覧と同じ処理を1件で呼ぶ（中身は消さない）
  _keepDelete(akaireFileId, name, fromAkairePage) {
    $.ajax({
      url: '/bulk_delete_akaire_files',
      method: 'POST',
      data: { ids: [akaireFileId], mode: 'keep' },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
    }).done(() => {
      $('#akf-del-overlay').hide()
      if (fromAkairePage) {
        window.location.href = '/all_akaire_files'
      } else {
        const row = $(`#sortable-${akaireFileId}`)
        row.fadeOut(200, function() { $(this).remove() })
        $(`#thumb-akaire-file-${akaireFileId}`).fadeOut(200, function() { $(this).remove() })
        $(`#modalMenu-${akaireFileId}`).remove()
        $(`#modalSelectStatus-${akaireFileId}`).remove()
        $(`#modalShowThumbnailSPDetail-${akaireFileId}`).remove()
        Popup.alert('30日間保管に移動しました。全ファイルページのゴミ箱から復元できます。', '', '', { timer: 7000 })
      }
    }).fail((xhr) => {
      $('#akf-del-overlay').hide()
      const msg = (xhr.responseJSON && xhr.responseJSON.error) || I18n.t('shared.one_error_please_try_again')
      Popup.alert(msg)
    })
  }

  _handleDelete(akaireFileId, name, fromAkairePage) {
    const url = Routes.delete_akaire_file_akaire_file_index_path(akaireFileId)
    Shared.callAjax(url, {}).done((data) => {
      if (fromAkairePage) {
        window.location.href = data.redirect_path
      } else {
        const row = $(`#sortable-${akaireFileId}`)
        row.fadeOut(200, function() { $(this).remove() })
        $(`#thumb-akaire-file-${akaireFileId}`).fadeOut(200, function() { $(this).remove() })
        $(`#modalMenu-${akaireFileId}`).remove()
        $(`#modalSelectStatus-${akaireFileId}`).remove()
        $(`#modalShowThumbnailSPDetail-${akaireFileId}`).remove()
      }
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  async deleteAkaireFileInfo(akaireFileId, name) {
    Popup.confirm(
      `「${name}」の赤入れデータを削除します。<br>復元できません。削除してよろしいですか？`,
      {
        success: () => {
          this._handleDelete(akaireFileId, name)
        },
        cancel: () => {},
        confirmText: 'OK',
        width: 'auto',
      }
    )
  }

  selectSearchType(ele, type) {
    $(ele).addClass('slted')
    const divEle = $(ele).parents('.dropdown-body')
    divEle.find(`input.search_for_${type}`).val('true')
  }

  resetAllSearchType(ele) {
    $(ele).parents('.td-filter-box').find('input[type="checkbox"]').prop('checked', false)
    $(ele).parents('.td-filter-box').find('div.slted').removeClass('slted')
  }

  showModalSearchForType(ele, type) {
    $(ele).parents('.modal').modal('hide')
    $(`#modalShowSearchList${type}`).modal('show')
  }

  selectPage(element) {
    const modal = $('#uploadVersionPopup')
    var page = $(element).attr('data-page-id')
    var page_name = $(element).text()
    var total_version = $(element).attr('data-total-vesion');
    modal.attr('data-page-id', page)
    modal.find('.akaire-page-name').html(page_name)
    modal.find('.count-total-version').html(`Ver ${total_version} にアップロードされます。`)
  }

  updateAkaireFileName(akaire_file_id) {
    const akaireFileName = $('#settingAkaireFileNamePopup').find('#akaire-file-name').val()
    $('.akaire_file_name').val(akaireFileName).trigger('change')
    Popup.confirm( `赤入れファイル名：${akaireFileName} <br> に変更されました。`, {
        success: () => { this.openSettingMember() },
        cancel: () => { this.openSettingMember() },
        successBtn: 'false',
        width: 'auto',
        kind: 'akaire'
      })
  }

  updateProjectName(project_id) {
    const projectName = $('#settingProjectNamePopup').find('#project-name').val()
    Shared.callAjax(
      Routes.update_project_name_owner_project_path(project_id),
      {project_name: projectName},
      '',
      'put'
    ).done((data) => {
      $('#settingAkaireFileNamePopup').modal('show');
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  handleOpenSettingMember(event) {
    if($(event.target).parents('.loading-overlay').length == 1) return
    if($(event.target).parents('.preloader').length == 1) return
    if(event.target.tagName == 'BODY') return

    if((($(event.target).parents('#settingAkaireFileNamePopup').length == 0) && $('#settingAkaireFileNamePopup').is(':visible')) ||
      ($(event.target).parents('#settingProjectNamePopup').length == 0) && $('#settingProjectNamePopup').is(':visible')){
      this.openSettingMember()
    }
  }

  openSettingMember(){
    if($('#modal-show-notify-mobile').length == 1) return

    setTimeout(function(){
      $('#click-show-list-member-of-akaire-page-detail').trigger('click')
    }, 200);
  }

  updateSelectDisplayFile(object_id, objectType, selectValue, typeMode = 'pcMode') {
    const url = Routes.update_display_type_file_akaire_file_index_path()
    Shared.callAjax(url, { select_value: selectValue, object_id: object_id, object_type: objectType }, '', 'post').done((data) => {
      location.reload()
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  selectMultiOptionModalSearchTask(type, taskId, element){
    const classOfElement = $(element).attr('class');
    if(classOfElement.includes('slted')) {
      $(element).removeClass('slted')
      $(element).find("input[type='checkbox']").prop('checked', false)
    } else {
      $(element).addClass('slted')
      $(element).parent().find('.option-all').removeClass('slted')
      $(element).find("input[type='checkbox']").prop('checked', true).change()
    }
    this.checkedAndRemoveCheckedSearchTicket(element, taskId)
  }

  checkedAndRemoveCheckedSearchTicket(ele, taskId) {
    const componentListWork = $('.filter-list-work')
    const componentListTask = $('.filter-list-task')
    const modalSearchListTask = $('#modalShowSearchListTask')
    const modalSearchListWork = $('#modalShowSearchListWork')
    const listTaskChecked = []
    const allListWork = componentListWork.find('div.option')
    if (window.innerWidth > 1023) {
      componentListTask.find('input[type="checkbox"]:checked').toArray().forEach(task => {
        listTaskChecked.push($(task).val())
      })
    } else {
      modalSearchListTask.find('input[type="checkbox"]:checked').toArray().forEach(task => {
        listTaskChecked.push($(task).val())
      })
    }
    modalSearchListWork.find('.dropdown-body').find('div.option').toArray().forEach(div => {
      if (listTaskChecked.includes($(div).attr('data-task-id'))) {
        $(div).removeClass('d-none')
      } else {
        $(div).removeClass('slted').addClass('d-none')
        $(div).find('input[type="checkbox"]').prop('checked', false)
      }
    })
    allListWork.toArray().forEach(div => {
      if (listTaskChecked.includes($(div).attr('data-task-id'))) {
        $(div).removeClass('d-none')
      } else {
        $(div).removeClass('slted').addClass('d-none')
        $(div).find('input[type="checkbox"]').prop('checked', false)
      }
    })
  }

  openUploadNewPageModal() {
    Shared.showModalForElement('#uploadNewPagePopup')
    $('#uploadNewPagePopup').attr('data-upload-new', 'true')
  }

  openUploadVersionModal() {
    Shared.showModalForElement('#uploadVersionPopup')
    $('#uploadNewPagePopup').attr('data-upload-new', 'false')
  }

  showPositionOfFile(akaireFileID) {
    const modalPositionOfFile = $('#modal-position-of-akaire-file')
    const url = Routes.fetch_position_of_file_akaire_file_path(akaireFileID)
    Shared.callAjax(url, { akaire_file_id: akaireFileID }, 'json', 'get').done((data) => {
      modalPositionOfFile.find('#akaire-file-id').val(akaireFileID)
      modalPositionOfFile.find('#type-change').val(data.type_change)
      modalPositionOfFile.find('#project-id').val(data.project_id)
      modalPositionOfFile.find('#task-id').val(data.task_id)

      modalPositionOfFile.find('.project-name').text(Project.truncateProjectName(data.project_name))
      modalPositionOfFile.find('.task-name').text(Project.truncateProjectName(data.task_name))
      modalPositionOfFile.find('.file-name').text(Project.truncateProjectName(data.file_name))

      if(data.is_show_task && data.task_id) {
        modalPositionOfFile.find('.task-setting').removeClass('d-none')
        modalPositionOfFile.find('.task-name').text(Project.truncateProjectName(data.task_name))
        modalPositionOfFile.find('.task-name').attr('onclick', `AkaireFile.selectTaskChangeFile('${data.project_id}', '${akaireFileID}')`)
      } else {
        modalPositionOfFile.find('.task-setting').addClass('d-none')
        modalPositionOfFile.find('.task-name.task-setting').addClass('text-red')
        modalPositionOfFile.find('.task-name').text('')
        modalPositionOfFile.find('.task-name').attr('onclick', '')
      }

      modalPositionOfFile.find('.setting-show-task').html(this.contentSettingShowTaskInModalPositionOfFile(data.is_show_task, data.project_name, data.project_id))
      modalPositionOfFile.modal('show')
    }).fail((response) => {
      if (response.responseJSON && response.responseJSON.message) {
        Popup.alert(response.responseJSON.message)
      } else {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      }
    })
  }

  showCreateTaskOptionsModal(projectId, akaireFileID) {
    $('#createTaskModal').modal('show');
    $('#createTaskModal').find('#project-id').val(projectId);
    $('#createTaskModal').find('#akaire-file-id').val(akaireFileID);
    $('#createTaskModal').find('#taskName').val('');
    $('#modal-change-position-akaire-file-task').modal('hide');
  }

  createTask() {
    $('#modal-change-position-akaire-file-task').modal('hide')
    $('#modal-change-position-akaire-file-project').modal('hide')
    $('#createTaskModal').modal('hide');
    $('#modal-accept-change-position-akaire-file-task').modal('show')
  }

  contentSettingShowTaskInModalPositionOfFile(is_show_task, project_name, project_id) {
    if (is_show_task.toString() == 'true') {
      return `
        <span>※現在、${Project.truncateProjectName(project_name, 12)}は、</span>
        <span class='text-show-task'>タスク利用中</span>
        <span>です。</span>
        <span class='text-hidden-task'>タスク非表示</span>
        <span>に切り替えると、</span>
        <span>タスクへの紐づけができなくなります。</span>
        <a href="javascript:void(0)" onclick="Project.hiddenTaskForProject(${project_id}, '${project_name}', event)" class='text-underline text-red'>切り替える</a>
      `
    } else {
      return `
        <span>※現在、${Project.truncateProjectName(project_name, 12)}は、</span>
        <span class='text-hidden-task'>タスク非表示</span>
        <span>です。</span>
        <span class='text-show-task'>タスク利用中</span>
        <span>に切り替えると、</span>
        <span>タスクへの紐づけが可能になります。</span>
        <a href="javascript:void(0)" onclick="Project.showTaskForProject(${project_id}, '${project_name}', event)" class='text-underline text-red'>切り替える</a>
      `
    }
  }

  selectProjectForChange(ele, akaireFileID) {
    const modalProject = $('#modal-change-position-akaire-file-project')
    const url = Routes.fetch_list_project_of_user_akaire_file_index_path()
    const file = this;
    Shared.callAjax(url, { akaire_file_id: akaireFileID }).done(function(response) {
      modalProject.find('#render-list-project').empty().append(response.html)
      const btnWrap0 = modalProject[0].querySelector('.save-dest-confirm-wrap')
      if (btnWrap0) btnWrap0.style.display = ''
      modalProject[0].querySelectorAll('.save-dest-bc-project, .save-dest-bc-task').forEach(e => e.classList.remove('save-dest-bc-active'))
      const pbBc = modalProject[0].querySelector('.save-dest-bc-project'); if (pbBc) pbBc.classList.add('save-dest-bc-active')
      const btnEl0 = modalProject[0].querySelector('.btn-save-dest-confirm')
      if (btnEl0) btnEl0.style.display = 'block'
      const pos = $('#modal-position-of-akaire-file')
      pos.find('#akaire-file-id').val(akaireFileID)
      const wrap = modalProject[0].querySelector('.project-change-list-wrapper')
      const curId = wrap ? wrap.querySelector('.project-change-row')?.getAttribute('data-current-id') : ''
      if (!pos.find('#project-id').val() && curId) {
        pos.find('#project-id').val(curId)
        pos.find('#type-change').val('project_change')
      }
      file._restoreSelectedRow(modalProject[0])
      file._setSaveDestBreadcrumb(modalProject[0], akaireFileID)
      $('.modal.show[id^="modalMenu-"]').modal('hide')
      modalProject.modal('dispose')
      modalProject.modal('show')
    }).fail(function(response) {
      file.showErrorNotChanPosition(response)
    })
  }

  filterProjectForChange(input) {
    const modal = document.getElementById('modal-change-position-akaire-file-project')
    if (!modal) return
    const keyword = (input.value || '').trim().toLowerCase()
    const rows = Array.from(modal.querySelectorAll('tbody.project-change-row tr.project-change-tr'))
    const matched = []
    rows.forEach(tr => {
      const name = (tr.getAttribute('data-name') || '').toLowerCase()
      const hit = keyword === '' || name.indexOf(keyword) !== -1
      tr.setAttribute('data-matched', hit ? '1' : '0')
      if (hit) matched.push(tr)
    })
    matched.forEach((tr, i) => { tr.setAttribute('data-page', String(Math.floor(i / 10) + 1)) })
    this.renderPageProjectChange(modal, 1)
    this.rebuildPagyProjectChange(modal, matched.length)
  }

  renderPageProjectChange(modal, page) {
    const rows = Array.from(modal.querySelectorAll('tbody.project-change-row tr.project-change-tr'))
    rows.forEach(tr => {
      const matched = tr.getAttribute('data-matched') !== '0'
      const onPage = Number(tr.getAttribute('data-page')) === Number(page)
      tr.style.display = (matched && onPage) ? '' : 'none'
    })
  }

  rebuildPagyProjectChange(modal, matchedCount) {
    const ul = modal.querySelector('.project-change-pagy-wrapper ul.pagination')
    if (!ul) return
    const maxPage = Math.max(1, Math.ceil(matchedCount / 10))
    const items = Array.from(ul.querySelectorAll('li.page-item[data-index]'))
    items.forEach(li => {
      const idx = Number(li.getAttribute('data-index'))
      li.classList.toggle('active', idx === 1)
      li.classList.toggle('d-none', idx > maxPage)
    })
  }

  prevPageProjectChange(ele) {
    const modal = ele.closest('#modal-change-position-akaire-file-project')
    if (!modal) return
    const ul = ele.closest('ul.pagination')
    const active = ul.querySelector('li.active')
    const cur = Number(active.getAttribute('data-index'))
    if (cur <= 1) return
    active.classList.remove('active')
    const target = ul.querySelector(`li[data-index="${cur - 1}"]`)
    if (target) target.classList.add('active')
    this.renderPageProjectChange(modal, cur - 1)
  }

  nextPageProjectChange(ele, maxPage) {
    const modal = ele.closest('#modal-change-position-akaire-file-project')
    if (!modal) return
    const ul = ele.closest('ul.pagination')
    const active = ul.querySelector('li.active')
    const cur = Number(active.getAttribute('data-index'))
    const visibleMax = ul.querySelectorAll('li.page-item[data-index]:not(.d-none)').length
    if (cur >= visibleMax) return
    active.classList.remove('active')
    const target = ul.querySelector(`li[data-index="${cur + 1}"]`)
    if (target) target.classList.add('active')
    this.renderPageProjectChange(modal, cur + 1)
  }

  selectPageProjectChange(ele) {
    const modal = ele.closest('#modal-change-position-akaire-file-project')
    if (!modal) return
    const page = ele.getAttribute('data-index')
    const ul = ele.closest('ul.pagination')
    const active = ul.querySelector('li.active')
    if (active) active.classList.remove('active')
    ele.classList.add('active')
    this.renderPageProjectChange(modal, page)
  }

  _ensureSaveDestUI(modal) {
    if (!modal || modal.querySelector('.save-dest-breadcrumb')) return
    const title = modal.querySelector('.modal-title span')
    if (title) title.textContent = '\u4fdd\u5b58\u5148\u306e\u5909\u66f4'
    const list = modal.querySelector('#render-list-project')
    if (!list) return
    const bc = document.createElement('div')
    bc.className = 'save-dest-modal-body px-3'
    bc.innerHTML = '<p class="text-left font-weight-bold mb-1">\u73fe\u5728\u3001\u4ee5\u4e0b\u306e\u968e\u5c64\u306b\u30d5\u30a1\u30a4\u30eb\u304c\u4fdd\u5b58\u3055\u308c\u3066\u3044\u307e\u3059\u3002\u79fb\u52d5\u5148\u3092\u9078\u629e\u5f8c\u300c\u78ba\u5b9a\u3059\u308b\u300d\u3092\u30af\u30ea\u30c3\u30af\u3057\u3066\u304f\u3060\u3055\u3044\u3002</p>'
      + '<div class="save-dest-breadcrumb text-left mb-2">'
      + '<span class="save-dest-bc-project cursor-pointer" onclick="AkaireFile.switchToProjectListInModal()"><small class="d-block text-muted">\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u540d</small><span class="save-dest-bc-project-name font-weight-bold text-underline"></span></span>'
      + '<span class="mx-1 save-dest-bc-task-wrap">&gt;</span>'
      + '<span class="save-dest-bc-task cursor-pointer save-dest-bc-task-wrap" onclick="AkaireFile.switchToTaskListInModal()"><small class="d-block text-muted">\u30bf\u30b9\u30af\u540d</small><span class="save-dest-bc-task-name font-weight-bold text-underline"></span></span>'
      + '<span class="mx-1">&gt;</span>'
      + '<span class="save-dest-bc-file"><small class="d-block text-muted">\u30d5\u30a1\u30a4\u30eb\u540d</small><span class="save-dest-bc-file-name"></span></span>'
      + '</div>'
    list.parentNode.insertBefore(bc, list)
    const btnWrap = document.createElement('div')
    btnWrap.className = 'd-flex justify-content-center mt-3 mb-3'
    btnWrap.innerHTML = '<button type="button" class="btn btn-primary btn-save-dest-confirm" onclick="AkaireFile.confirmSaveDestChange()">\u78ba\u5b9a\u3059\u308b</button>'
    list.parentNode.insertBefore(btnWrap, list.nextSibling)
  }

  _restoreSelectedRow(modal) {
    if (!modal) return
    const pos = $('#modal-position-of-akaire-file')
    const isTask = !!modal.querySelector('tr.task-change-tr')
    const selId = isTask ? pos.find('#task-id').val() : pos.find('#project-id').val()
    modal.querySelectorAll('tr.save-dest-selected').forEach(t => { t.classList.remove('save-dest-selected'); const c = t.querySelector('.project-change-check'); if (c) c.style.visibility = 'hidden' })
    if (!selId) return
    modal.querySelectorAll('tr.project-change-tr').forEach(tr => {
      const oc = tr.getAttribute('onclick') || ''
      const m = oc.match(/'(\d+)'/)
      if (m && m[1] === String(selId)) {
        tr.classList.add('save-dest-selected')
        const c = tr.querySelector('.project-change-check'); if (c) c.style.visibility = 'visible'
      }
    })
  }

  _truncBc(v) {
    v = v || ''
    return v.length > 20 ? v.slice(0, 20) + '...' : v
  }

  _setSaveDestBreadcrumb(modal, fileId) {
    if (!modal) return
    const wrap = modal.querySelector('.project-change-list-wrapper')
    if (!wrap) return
    const pos = $('#modal-position-of-akaire-file')
    const showTask = wrap.getAttribute('data-current-show-task') === 'true'
    const fName = wrap.getAttribute('data-current-file') || ''
    const selRow = modal.querySelector('tr.save-dest-selected')
    const pName = (selRow && selRow.getAttribute('data-name')) || wrap.getAttribute('data-current-project') || ''
    const setTxt = (sel, v) => { const e = modal.querySelector(sel); if (e) e.textContent = v }
    setTxt('.save-dest-bc-project-name', this._truncBc(pName))
    setTxt('.save-dest-bc-file-name', this._truncBc(fName))
    if (showTask) {
      const tEl = modal.querySelector('.save-dest-bc-task-name')
      const hasTaskSel = !!pos.find('#task-id').val()
      if (!hasTaskSel) {
        const curTask = wrap.getAttribute('data-current-task') || ''
        if (tEl) tEl.textContent = this._truncBc(curTask || '\u672a\u9078\u629e')
      }
    } else {
      setTxt('.save-dest-bc-task-name', '')
    }
    modal.querySelectorAll('.save-dest-bc-task-wrap').forEach(e => e.style.display = showTask ? '' : 'none')
  }

  selectRowProjectForChange(ele, projectId, projectName, isShowTask) {
    const modal = ele.closest('#modal-change-position-akaire-file-project')
    if (!modal) return
    const pos = $('#modal-position-of-akaire-file')
    const tr = ele.closest('tr')
    const already = tr.classList.contains('save-dest-selected')
    const wrap = modal.querySelector('.project-change-list-wrapper')
    const curId = wrap ? (wrap.querySelector('.project-change-row')?.getAttribute('data-current-id') || '') : ''
    const setSelected = (rowEl, pid, pname, showT) => {
      modal.querySelectorAll('tr.save-dest-selected').forEach(t => { t.classList.remove('save-dest-selected'); const c = t.querySelector('.project-change-check'); if (c) c.style.visibility = 'hidden' })
      if (rowEl) { rowEl.classList.add('save-dest-selected'); const c = rowEl.querySelector('.project-change-check'); if (c) c.style.visibility = 'visible' }
      pos.find('#project-id').val(pid)
      pos.find('#task-id').val('')
      pos.find('#type-change').val('project_change')
      pos.find('.project-name').text(pname)
      pos.find('.task-name').text('')
      const m = modal.querySelector('.save-dest-bc-project-name'); if (m) m.textContent = this._truncBc(pname)
      const mt = modal.querySelector('.save-dest-bc-task-name'); if (mt) mt.textContent = (showT === 'true' || showT === true) ? this._truncBc('\u672a\u9078\u629e') : ''
      modal.querySelectorAll('.save-dest-bc-task-wrap').forEach(e => e.style.display = (showT === 'true' || showT === true) ? '' : 'none')
    }
    if (!already) {
      setSelected(tr, projectId, projectName, isShowTask)
    } else {
      const curRow = Array.prototype.find.call(modal.querySelectorAll('tr.project-change-tr'), r => {
        const oc = r.getAttribute('onclick') || ''; const mm = oc.match(/'(\d+)'/); return mm && mm[1] === String(curId)
      })
      const curName = wrap ? (wrap.getAttribute('data-current-project') || '') : ''
      const curShow = wrap ? wrap.getAttribute('data-current-show-task') : 'false'
      setSelected(curRow, curId, curName, curShow)
    }
  }

  switchToProjectListInModal() {
    const fid = $('#modal-position-of-akaire-file').find('#akaire-file-id').val()
    if (fid) this.selectProjectForChange(null, fid)
  }

  switchToTaskListInModal() {
    const modal = document.getElementById('modal-change-position-akaire-file-project')
    if (!modal) return
    const pos = $('#modal-position-of-akaire-file')
    const projectId = pos.find('#project-id').val()
    const akaireFileID = pos.find('#akaire-file-id').val()
    if (!projectId || !akaireFileID) return
    const file = this
    const url = Routes.fetch_list_task_of_user_akaire_file_index_path()
    Shared.callAjax(url, { akaire_file_id: akaireFileID, project_id: projectId }).done(function(response) {
      const list = modal.querySelector('#render-list-project')
      if (list) list.innerHTML = response.html
      const noTask = !!modal.querySelector('.save-dest-no-task-msg')
      const btnWrap = modal.querySelector('.save-dest-confirm-wrap')
      const btnEl = modal.querySelector('.btn-save-dest-confirm')
      if (btnWrap) btnWrap.style.display = noTask ? 'none' : ''
      if (btnEl) btnEl.style.display = noTask ? 'none' : 'block'
      const input = modal.querySelector('.project-change-search-input')
      if (input) { input.value = ''; input.setAttribute('placeholder', '\u691c\u7d22\u3059\u308b'); input.setAttribute('oninput', 'AkaireFile.filterProjectForChange(this)') }
      modal.querySelectorAll('.save-dest-bc-project, .save-dest-bc-task').forEach(e => e.classList.remove('save-dest-bc-active'))
      const tabBc = modal.querySelector('.save-dest-bc-task'); if (tabBc) tabBc.classList.add('save-dest-bc-active')
      if (pos.find('#task-id').val()) file._restoreSelectedRow(modal)
    }).fail(function(response) {
      file.showErrorNotChanPosition(response)
    })
  }

  selectRowTaskForChange(ele, taskId, taskName) {
    const modal = ele.closest('#modal-change-position-akaire-file-project')
    if (!modal) return
    const pos = $('#modal-position-of-akaire-file')
    const tr = ele.closest('tr')
    const already = tr.classList.contains('save-dest-selected')
    modal.querySelectorAll('tr.save-dest-selected').forEach(t => { t.classList.remove('save-dest-selected'); const c = t.querySelector('.project-change-check'); if (c) c.style.visibility = 'hidden' })
    const mt = modal.querySelector('.save-dest-bc-task-name')
    if (!already) {
      tr.classList.add('save-dest-selected')
      const c = tr.querySelector('.project-change-check'); if (c) c.style.visibility = 'visible'
      pos.find('#task-id').val(taskId)
      pos.find('#type-change').val('task_change')
      if (mt) mt.textContent = this._truncBc(taskName)
    } else {
      pos.find('#task-id').val('')
      pos.find('#type-change').val('project_change')
      if (mt) mt.textContent = '\u672a\u9078\u629e'
    }
  }

  showErrorNotChanPosition(response) {
    if (response.responseJSON && response.responseJSON.not_owner) {
      Popup.alert('ファイルの所有者以外は<br>保存先を変更できません。')
      return
    }
    Popup.alert(I18n.t('shared.one_error_please_try_again'))
  }

  showSelectProject(ele, projectId, akaireFileID, projectName, isShowTask) {
    const modalShowSelectProject = $('#modal-accept-change-position-akaire-file-project')
    modalShowSelectProject.find('.show-project-select').text(projectName)
    let onclick = ''
    if (isShowTask == 'true') {
      onclick = `AkaireFile.selectTaskChangeFile('${projectId}', '${akaireFileID}')`
    } else {
      onclick = `AkaireFile.acceptSelectProject('${projectId}', '${akaireFileID}', '${projectName}', '${isShowTask}')`
    }
    modalShowSelectProject.find('.btn-select-project').attr('onclick', onclick)
    $('#modal-change-position-akaire-file-project').modal('hide')
    modalShowSelectProject.modal('show')
  }

  acceptSelectProject(projectId, akaireFileID, projectName, isShowTask) {
    $('#modal-accept-change-position-akaire-file-project').modal('hide')
    $('#modal-accept-change-position-akaire-file-task').modal('hide')
    $('#modal-change-position-akaire-file-task').modal('hide')
    $('#modal-position-of-akaire-file').find('.project-name').text(projectName)
    $('#modal-position-of-akaire-file').find('#project-id').val(projectId)
    $('#modal-position-of-akaire-file').find('#task-id').val(null)
    $('#modal-position-of-akaire-file').find('#akaire-file-id').val(akaireFileID)
    $('#modal-position-of-akaire-file').find('#type-change').val('project_change')
    $('#modal-position-of-akaire-file').find('.task-setting').addClass('d-none')
    $('#modal-position-of-akaire-file').find('.setting-show-task').html(this.contentSettingShowTaskInModalPositionOfFile(isShowTask, projectName, projectId))
    $('#modal-position-of-akaire-file').find('.btn-submit-change-position').removeClass('d-none')
    $('#modal-position-of-akaire-file').modal('show')
  }

  acceptSelectTask(taskId, projectId, akaireFileID, projectName, taskName, isShowTask) {
    $('#modal-change-position-akaire-file-task').modal('hide')
    $('#modal-accept-change-position-akaire-file-task').modal('hide')
    $('#modal-position-of-akaire-file').find('.task-name').text(taskName)
    $('#modal-position-of-akaire-file').find('.task-name').attr('onclick', `AkaireFile.selectTaskChangeFile('${projectId}', '${akaireFileID}')`)
    $('#modal-position-of-akaire-file').find('.project-name').text(projectName)
    $('#modal-position-of-akaire-file').find('#project-id').val(projectId)
    $('#modal-position-of-akaire-file').find('#task-id').val(taskId)
    $('#modal-position-of-akaire-file').find('#akaire-file-id').val(akaireFileID)
    $('#modal-position-of-akaire-file').find('#type-change').val('task_change')
    $('#modal-position-of-akaire-file').find('.task-setting').removeClass('d-none')
    $('#modal-position-of-akaire-file').find('.setting-show-task').html(this.contentSettingShowTaskInModalPositionOfFile(isShowTask, projectName, projectId))
    $('#modal-position-of-akaire-file').find('.btn-submit-change-position').removeClass('d-none')
    $('#modal-position-of-akaire-file').modal('show')
  }

  acceptChangePositionOfFile() {
    const projectId = $('#modal-position-of-akaire-file').find('#project-id').val()
    const akaireFileID = $('#modal-position-of-akaire-file').find('#akaire-file-id').val()
    const taskId = $('#modal-position-of-akaire-file').find('#task-id').val()
    const typeChange = $('#modal-position-of-akaire-file').find('#type-change').val()
    if (gon.is_show_popup_confirm_change_position) {
      this.showPopupConfirm(`AkaireFile._handleChangePosition('${akaireFileID}', '${taskId}', '${projectId}', '${typeChange}')`, akaireFileID, projectId)
    } else {
      this._handleChangePosition(akaireFileID, taskId, projectId, typeChange)
    }
  }

  _handleChangePosition(akaireFileID, taskId, projectId, typeChange) {
    $('#popup-confirm-change-position-akaire-file').modal('hide')
    $('#popup-confirm-change-position-akaire-file-not-compare-project').modal('hide')
    const ovl = document.getElementById('tm-savedest-confirm-overlay')
    if (ovl) { ovl.remove() }
    this._clearStuckModals()
    // 20260724: 確認モーダルのOKから来た場合はここが最初のクリック操作なので、この瞬間に別ウィンドウを開く
    if (!this._saveDestWin || this._saveDestWin.closed) {
      this._saveDestWin = window.open('', '_blank')
      if (this._saveDestWin) { this._saveDestWin.document.write(this._saveDestLoadingHtml()) }
    }
    const modalSuccess = $('#popup-success-change-position-akaire-file')
    const newWin = this._saveDestWin
    this._saveDestWin = null
    const destName = this._saveDestCompanyName || ''
    this._saveDestCompanyName = ''
    const url = Routes.change_position_akaire_file_akaire_file_index_path()
    Shared.callAjax(url, {
      akaire_file_id: akaireFileID, task_id: taskId, type_change: typeChange,
      project_id: projectId
    }).done(function(response) {
      const target = response.url + `?show_popup_change_file_id=${akaireFileID}`
      if (newWin && !newWin.closed) {
        newWin.location.href = target
      } else {
        window.open(target, '_blank')
      }
      // FIX 20260724-savedest : 移動元ページに移動済みファイルが残るため、少し待ってから再読み込みする
      setTimeout(function() { window.location.reload() }, 1000)
    }).fail(function(response) {
      if (newWin && !newWin.closed) { newWin.close() }
      if (response.responseJSON && response.responseJSON.error_type) {
        let message = ''
        switch(response.responseJSON.error_type) {
          case 'max_quantity_files':
            message = (destName ? destName + 'の' : '') + 'ファイル数がプラン上限をオーバーしている為、<br>保管先として更新できませんでした。'
            break;
          case 'max_total_file_size':
            message = '容量をオーバーしている為、保管先を更新できません。'
            break;
          case 'max_total_video_embed':
            message = 'YouTubeの赤入れをオーバーしている為、保管先を更新できません。'
            break;
          case 'max_total_login_pages':
            message = 'ID・PASSサイトの赤入れをオーバーしている為、保管先を更新できません。'
            break;
        }
        Popup.alert(message, '', '', { duration: 5000 })
        return
      }
      Popup.alert(I18n.t('shared.one_error_please_try_again'), '', '', { duration: 5000 })
    })
  }

  changeShowPopupConfirmPositionFile(ele) {
    const url = Routes.change_show_popup_confirm_akaire_file_akaire_file_index_path()
    const isChecked = $(ele).prop('checked')
    Shared.callAjax(url, { is_show: !isChecked }).done(function(response) {
      gon.is_show_popup_confirm_change_position = response.is_show
    }).fail(function(error) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  _saveDestLoadingHtml() {
    return '<!doctype html><html><head><meta charset="utf-8"><title>読み込み中</title>'
      + '<style>'
      + 'html,body{height:100%;margin:0}'
      + 'body{display:flex;flex-direction:column;align-items:center;justify-content:center;'
      + 'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;'
      + 'background:#f7f8fa;color:#555}'
      + '.sp{width:44px;height:44px;border:4px solid #e0e3e8;border-top-color:#3b82f6;'
      + 'border-radius:50%;animation:sp 0.8s linear infinite}'
      + '.tx{margin-top:18px;font-size:15px;letter-spacing:.02em}'
      + '@keyframes sp{to{transform:rotate(360deg)}}'
      + '</style></head><body>'
      + '<div class="sp"></div>'
      + '<div class="tx">新しい保存先を開いています…</div>'
      + '</body></html>'
  }

  // FIX 20260724-savedest : 保存先変更の確認パネル（共通ヘッダー無し・黒パネル）
  // 開いたままのBootstrapモーダルと暗幕を確実に片付ける（旧ページが固まる不具合の対策）
  _clearStuckModals() {
    $('#modal-position-of-akaire-file').modal('hide')
    $('#modal-change-position-akaire-file-project').modal('hide')
    $('#popup-confirm-change-position-akaire-file').modal('hide')
    $('#popup-confirm-change-position-akaire-file-not-compare-project').modal('hide')
    setTimeout(function() {
      var bds = document.querySelectorAll('.modal-backdrop')
      for (var k = 0; k < bds.length; k++) { bds[k].remove() }
      document.body.classList.remove('modal-open')
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }, 400)
  }

  _showSaveDestConfirmPanel(companyName, fileName, onOk) {
    const self = this
    const old = document.getElementById('tm-savedest-confirm-overlay')
    if (old) { old.remove() }

    const overlay = document.createElement('div')
    overlay.id = 'tm-savedest-confirm-overlay'
    overlay.setAttribute('style', 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:20000;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;')

    const panel = document.createElement('div')
    panel.className = 'tm-invite-link-panel'
    panel.setAttribute('style', 'background:#1a1a1a;color:#fff;border-radius:16px;box-shadow:0 20px 48px rgba(0,0,0,.6);padding:32px 28px 24px;max-width:500px;width:calc(100vw - 48px);text-align:left;font-family:sans-serif;')

    const msg = document.createElement('p')
    msg.setAttribute('style', 'font-size:15px;line-height:1.9;margin:0 0 18px;font-weight:700;color:#fff;text-align:left;')
    msg.appendChild(document.createTextNode(companyName + 'がオーナーのプロジェクトです。'))
    msg.appendChild(document.createElement('br'))
    msg.appendChild(document.createTextNode('「' + fileName + '」の所有者（容量負担含む）が、' + companyName + 'に移動します。'))
    panel.appendChild(msg)

    const ask = document.createElement('p')
    ask.setAttribute('style', 'font-size:15px;line-height:1.8;margin:0 0 22px;font-weight:700;color:#fff;text-align:center;')
    ask.textContent = '保存先を変更してよろしいですか？'
    panel.appendChild(ask)

    const btnWrap = document.createElement('div')
    btnWrap.setAttribute('style', 'display:flex;justify-content:center;align-items:center;gap:16px;margin-top:4px;')
    const okBtn = document.createElement('button')
    okBtn.type = 'button'
    okBtn.className = 'tm-savedest-ok'
    okBtn.setAttribute('style', 'padding:9px 36px;border:none;border-radius:10px;background:#fff;color:#1a1a1a;font-size:15px;font-weight:700;cursor:pointer;')
    okBtn.textContent = 'OK'
    const cancelBtn = document.createElement('button')
    cancelBtn.type = 'button'
    cancelBtn.className = 'tm-savedest-cancel'
    cancelBtn.setAttribute('style', 'padding:9px 28px;border:none;border-radius:10px;background:rgba(255,255,255,.12);color:#fff;font-size:15px;font-weight:700;cursor:pointer;')
    cancelBtn.textContent = 'キャンセル'
    btnWrap.appendChild(okBtn)
    btnWrap.appendChild(cancelBtn)
    panel.appendChild(btnWrap)

    overlay.appendChild(panel)
    document.body.appendChild(overlay)

    okBtn.addEventListener('click', function(ev) {
      ev.preventDefault(); ev.stopPropagation()
      overlay.remove()
      onOk()
    })
    cancelBtn.addEventListener('click', function(ev) {
      ev.preventDefault(); ev.stopPropagation()
      overlay.remove()
      self._clearStuckModals()
    })

    self._clearStuckModals()
  }

  confirmSaveDestChange() {
    this._saveDestCompanyName = ''
    this._saveDestWin = window.open('', '_blank')
    if (this._saveDestWin) {
      this._saveDestWin.document.write(this._saveDestLoadingHtml())
    }
    const pos = $('#modal-position-of-akaire-file')
    const projectId = pos.find('#project-id').val()
    const akaireFileID = pos.find('#akaire-file-id').val()
    const taskId = pos.find('#task-id').val()
    const typeChange = pos.find('#type-change').val()
    const file = this
    const url = Routes.check_show_popup_change_akaire_file_akaire_file_index_path()
    Shared.callAjax(url, { akaire_file_id: akaireFileID, project_id: projectId }).done(function(response) {
      if (response.new_company) {
        // 20260724: 確認パネルを出す回は、先に開いた空ウィンドウを一旦閉じ、OK押下時に開き直す
        if (file._saveDestWin && !file._saveDestWin.closed) { file._saveDestWin.close() }
        file._saveDestWin = null
        file._saveDestCompanyName = response.company_name
        $('#modal-change-position-akaire-file-project').modal('hide')
        file._showSaveDestConfirmPanel(response.company_name, response.file_name, function() {
          file._handleChangePosition(akaireFileID, taskId, projectId, typeChange)
        })
      } else {
        $('#modal-change-position-akaire-file-project').modal('hide')
        file._handleChangePosition(akaireFileID, taskId, projectId, typeChange)
      }
    }).fail(function(error) {
      if (file._saveDestWin && !file._saveDestWin.closed) { file._saveDestWin.close() }
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  showPopupConfirm(functionOnclick, akaireFileId, projectId) {
    const data = { akaire_file_id: akaireFileId, project_id: projectId }
    const url = Routes.check_show_popup_change_akaire_file_akaire_file_index_path()
    let confirmPopup = $('#popup-confirm-change-position-akaire-file')
    Shared.callAjax(url, data).done(function(response) {
      if (response.new_company) {
        confirmPopup = $('#popup-confirm-change-position-akaire-file-not-compare-project')
        confirmPopup.find('.show-name-company-new').text(response.company_name)
        confirmPopup.find('.file-name').text(response.file_name)
      }
      confirmPopup.find('.btn-onclick-confirm-change-position').attr('onclick', functionOnclick)
      confirmPopup.modal('show')
    }).fail(function(error) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  selectTaskChangeFile(projectId, akaireFileID) {
    const modalTask = $('#modal-change-position-akaire-file-task')
    const modalShowSelectProject = $('#modal-accept-change-position-akaire-file-project')
    modalShowSelectProject.modal('hide')
    const url = Routes.fetch_list_task_of_user_akaire_file_index_path()
    const file = this;
    Shared.callAjax(url, { akaire_file_id: akaireFileID, project_id: projectId }).done(function(response) {
      modalTask.find('#render-list-task').empty().append(response.html)
      modalTask.modal('show')
    }).fail(function(response) {
      file.showErrorNotChanPosition(response)
    })
  }

  showSelectTask(taskId, akaireFileID, projectId, projectName, taskName, isShowTask) {
    const modalShowSelectProject = $('#modal-accept-change-position-akaire-file-task')
    $('#modal-change-position-akaire-file-task').modal('hide')
    modalShowSelectProject.find('.show-task-select').text(taskName)
    let onclick = `AkaireFile.acceptSelectTask('${taskId}', '${projectId}', '${akaireFileID}', '${projectName}', '${taskName}', '${isShowTask}')`
    modalShowSelectProject.find('.btn-select-task').attr('onclick', onclick)
    $('#modal-change-position-akaire-file-project').modal('hide')
    modalShowSelectProject.modal('show')
  }

  changeStatusWithSelect(ele, akaireFileId, reload = false) {
    const status = $(ele).attr('value')
    const url = Routes.akaire_change_status_akaire_file_index_path(akaireFileId)
    Shared.callAjax(url, { status: status }, 'json').done(function(data) {
      if (reload) {
        Shared.reloadCurrentPage();
      } else {
        Popup.alert(I18n.t('task.update.status.success'))
      }
      $('#change-status-of_task-new').html(data)
    })
  }

  hideEditAkaireFileName(ele) {
    ele.parent().find('a').removeClass('d-none')
    ele.parent().find('.edit-akaire-file-name-img').removeClass('d-none')
    ele.parent().find('.thumb-akaire_file-name-content').removeClass('d-none')
    ele.parent().find('.thumb-akaire_file-name-capacity').removeClass('d-none')
    ele.addClass('d-none')
    ele.parent().find('.edit-akaire-file-name-backdrop').addClass('d-none')
  }

  handleChangeAkaireFileName(input, akaireFileId) {
    const newName = input.val()
    if (newName.length > 0) {
      const url = Routes.change_akaire_file_name_akaire_file_index_path(akaireFileId)
      Shared.callAjax(url, { name: newName }).done((data) => {
        input.parent().find('.link-show-name-akaire_file').text(newName)
        input.parent().find('.thumb-akaire_file-name-content').text(newName)
      }).fail((data) => {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      })
    }

    this.hideEditAkaireFileName(input)
  }

  showEditAkaireFileName(ele, akaireFileId) {
    $(ele).parent().find('a').addClass('d-none')
    $(ele).addClass('d-none')
    $(ele).parent().find('.thumb-akaire_file-name-content').addClass('d-none')
    $(ele).parent().find('.thumb-akaire_file-name-capacity').addClass('d-none')

    const nameInput = $(ele).parent().find('.input-akaire_file-text-name')
    const editBackdrop = $(ele).parent().find('.edit-akaire-file-name-backdrop')
    editBackdrop.removeClass('d-none')
    nameInput.removeClass('d-none')
    nameInput.trigger("focus")
    const isThumbnail = nameInput.hasClass('input-for-thumbnail')
    const isSP = Shared.checkDeviceWithTouchAction()

    if (isSP && !isThumbnail) {
      nameInput.attr('placeholder', 'ファイル名を変更')
    } else if (!isThumbnail) {
      nameInput.attr('placeholder', 'ファイル名を入力してください')
    }

    editBackdrop.on('click', () => {
      editBackdrop.off('click')

      this.handleChangeAkaireFileName(nameInput, akaireFileId)
    })

    nameInput.on('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.handleChangeAkaireFileName(nameInput, akaireFileId)
      }
      if (e.key === 'Escape') {
        e.preventDefault()
        nameInput.val(nameInput.data('origin-name'))
        this.hideEditAkaireFileName(nameInput)
      }
    })
  }

  bulkDownloadAttachments(akaireFileId) {
    const url = Routes.check_attachment_akaire_file_akaire_file_index_path(akaireFileId);
    Shared.callAjax(url, {}, 'json', 'GET')
    .done(function(data){
        if (data.attachment === 'blank') {
            $('#show-text-attachment-blank').removeClass('d-none');
            return;
        }
        if (data.akaire_file === 'blank') {
            location.reload();
            return;
        }
        $('#show-text-attachment-blank').addClass('d-none');
        window.location.href = $('#send-bulk-download').attr('href');
    }).fail(function(){
        location.reload();
    });
  };

  handleShowWarningUploadVideoYoutubeAds(ele) {
    const isChecked = $(ele).prop('checked')
    const url = Routes.hide_popup_warning_upload_video_youtube_ads_owner_users_path()
    Shared.callAjax(url, { is_checked: isChecked })
    .done(function() {})
    .fail(function() {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  showThumbnailToast(type, id) {
    $(`.akaire-thumb-${type}-label-zoom-${id}`).addClass('zoom-hover')
  }

  hideThumbnailToast(type, id) {
    $(`.akaire-thumb-${type}-label-zoom-${id}`).removeClass('zoom-hover')
  }
}
